import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IExceedMaxPriceBalanceTransaction } from '../interface/IExceedMaxPriceBalanceTransaction';

enum ExceedMaxPriceBalanceTransactionEnum {
  getByTradeId = "/get-by-trade-id/",
}

export default class ExceedMaxPriceBalanceTransactionService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/exceed-max-price-balance-transaction");
  }

  public getById = async (tradeId: number): Promise<IExceedMaxPriceBalanceTransaction> => await this.GET(ExceedMaxPriceBalanceTransactionEnum.getByTradeId + tradeId);
}
